module.exports = __webpack_public_path__ + "img/clamp_for_squarel_holder.prt.7d0ac31c.jpg";